import React, { Component } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementContextualSurvey from '../../ui/contextual-survey';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementFlag from '../../ui/flag';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementModalDialog from '../../ui/modal-dialog';

type Props = Record<string, any>;

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class EngagementMessages extends Component<Props> {
	render(): React.JSX.Element {
		return (
			<div>
				<EngagementModalDialog />
				<EngagementFlag />
				<EngagementContextualSurvey />
			</div>
		);
	}
}

// duplicate the export as a named one. That way, the export name in
// this entrypoint (defined in "af:exports") matches the name that is
// used in the main (src/index.ts) entrypoint.
export { EngagementMessages };
